import React from 'react';
import { StyledModalBodyV2 } from '../modalV2';
import {
  ScrollFadeClearance,
  ScrollFadeOverlay,
  ScrollProgressFill,
  ScrollProgressTrack,
  ScrollViewportShell
} from './modalScrollProgressStyles';

function WizardScrollableModalBody({ bodyRef, scroll, children, gap, style, ...rest }) {
  const showFade = scroll?.showChrome && !scroll?.isAtBottom;

  return (
    <ScrollViewportShell>
      <StyledModalBodyV2
        innerRef={bodyRef}
        gap="0px"
        style={style}
        {...rest}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: gap || '16px',
            width: '100%'
          }}>
          {children}
          <ScrollFadeClearance aria-hidden />
        </div>
      </StyledModalBodyV2>
      <ScrollProgressTrack
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
          opacity: scroll?.showChrome ? 1 : 0,
          pointerEvents: 'none',
          transition: 'opacity 0.2s ease'
        }}>
        <ScrollProgressFill $progress={scroll?.scrollProgress || 0} />
      </ScrollProgressTrack>
      {showFade ? <ScrollFadeOverlay aria-hidden /> : null}
    </ScrollViewportShell>
  );
}

export default WizardScrollableModalBody;
